import { saveResource, fetchResources, fetchResourceById } from '@/connectors/ras';

const initialState = () => ({
  resources: [],
  filters: { limit: 48, offset: 0 },
});

const getters = {
  currentTextureFile: (state) => state.textureFile,
  textureFiles: (state) => state.resources,
  textureFileFilters: (state) => state.filters,
};

const mutations = {
  setTextureFiles(state, texture) {
    Object.assign(state, { resources: texture });
  },
  setTextureFileFilters(state, filters) {
    Object.assign(state, { filters: { ...state.filters, ...filters } });
  },
  setCurrentTextureFile(state, data) {
    Object.assign(state, { textureFile: data });
  },
};

const actions = {
  async createTextureFile({ rootState }, textureData) {
    return saveResource(textureData, { request: rootState.users.user.session.request, resourceType: 'textureFile' });
  },
  async fetchTextureFileById({ rootState, commit }, id) {
    const response = await fetchResourceById(
      { id },
      { request: rootState.users.user.session.request, resourceType: 'textureFile' },
    );
    commit('setCurrentTextureFile', response.data);
  },
  async fetchTextureFiles({ state, rootState, commit }) {
    const response = await fetchResources(state.filters, {
      request: rootState.users.user.session.request,
      resourceType: 'textureFile',
    });
    commit('setTextureFiles', response.data.objects);
    commit('setTextureFileFilters', response.data.meta);
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
